import React, { useState } from "react";
import styled from "styled-components";
import { Paper, TextField, Button, CardHeader } from "@material-ui/core";
import "./App.css";
import Error from "./Error";
import Balance from "./Balance";
import Loading from "./Loading";

function App() {
  const [card, setCard] = useState("");
  const [balance, setBalance] = useState(false);
  const [error, setError] = useState(false);
  const [statusMsg, setStatusMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const updateTextField = e => {
    const value = e.target.value;
    setCard(value);
  };

  const submit = async e => {
    e.preventDefault();
    setStatusMsg("");
    setError(false);
    setLoading(true);

    if (card === "") {
      setError("cardNumber");
      setLoading(false);
      setStatusMsg("Card number is required");
      return;
    }

    let url = "https://www.firsttowndowntown.org/giftcards/index.php/balance";
    if (card) {
      url = url + `/${card}`;
    }

    const result = await fetch(url).then(resp => resp.json());

    if (result.data.status === "error") {
      setError("cardNumber");
      setStatusMsg("Invalid Card Number");
      setLoading(false);
      return;
    }

    if (result.data.status === "success") {
      setBalance(result.data.balance);
      setLoading(false);
    }
  };

  const addFundsTen = async e => {
    let url = "http://localhost:8000/action/add";
    url = "https://www.firsttowndowntown.org/giftcards/index.php/action/add";

    let formData = new FormData();
    formData.append("amount", "10");
    formData.append("account", "913418251599407");

    const result = await fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *client
      body: formData
    }).then(resp => resp.json());
    return result;
  };

  const addFundsTwentyFive = async e => {
    let url = "http://localhost:8000/action/add";
    url = "https://www.firsttowndowntown.org/giftcards/index.php/action/add";

    let formData = new FormData();
    formData.append("amount", "25");
    formData.append("account", "913418251599407");

    const result = await fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *client
      body: formData
    }).then(resp => resp.json());
    return result;
  };

  let cardNumberError = false;
  if (error === "cardNumber") {
    cardNumberError = true;
  }

  return (
    <StyledBalanceLookup>
      <Paper className="lookup-container">
        <CardHeader
          title="Balance Lookup"
          subheader="Enter your information below to check your current account balance."
        ></CardHeader>
        <form onSubmit={submit}>
          <TextField
            required
            type="text"
            onChange={updateTextField}
            label="Card Number"
            id="card-number"
            error={cardNumberError}
          />
          {error === "cardNumber" && statusMsg && <Error>{statusMsg}</Error>}
          {error === false && <div style={{ height: "15px" }}></div>}
          <div className="action">
            <Button className="submit" variant="contained" onClick={submit}>
              Submit
            </Button>
            {loading === true && <Loading />}
          </div>
        </form>
        {error === false && loading === false && balance && (
          <Balance amount={balance} />
        )}
      </Paper>
      <div
        style={{
          padding: "10px",
          backgroundColor: "#eee",
          marginTop: "20px",
          width: "350px",
          display: "none"
        }}
      >
        <h3>Debug:</h3>
        <em>913418251599407</em>
        <div className="buttons" style={{ padding: "10px 0" }}>
          <Button onClick={addFundsTen} variant="contained">
            Add $10
          </Button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button onClick={addFundsTwentyFive} variant="contained">
            Add $25
          </Button>
        </div>
      </div>
    </StyledBalanceLookup>
  );
}

export default App;

const StyledBalanceLookup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  /* 92363B */
  padding-top: 40px;

  .MuiCardHeader-title {
    margin-bottom: 8px;
  }

  .MuiCardHeader-subheader {
    line-height: 1.1;
    font-size: 14px;
  }

  .lookup-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    width: 350px;
    border-top: 10px solid #92363b;
  }

  form {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
  }

  .submit {
    width: 150px;
    margin: 15px auto;
    margin-right: 20px;
  }
`;
